const cashfreeMode = 'sandbox'; //for testing use 'sandbox' for live use 'production'

// Staging — daai-stage-imp layout on Milesweb. See:
// D:/Obsidian_files_memories/Daai-Saas/20_Development/2026-05-27-staging-deploy-plan-and-architecture.md
export const environment = {
  production: true,
  URL: 'https://stage-admin.daaisuite.in/daaisaas/',
  cashfreeMode: cashfreeMode,
  shareablePlanURL:
    'https://stage-checkout.daaisuite.in/authentication/sign-up?plan=',
  // Empty → fall back to per-tenant URL the staging backend returns on
  // `tenantData.url` (constructed via SaaS .env DOMAIN_URL).
  suiteUrl: '',
};
